/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import { LinkToAnotherAuth, submitSignIn } from '../components/authentication';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {
  PasswordInput,
  EmailInput,
} from '../components/authentication/AuthComponent';
import {
  BETA_TESTING,
  CONTACT_SUPPORT_LINK,
  SUPPORT_EMAIL,
} from '../constants';
import Form from '../components/Form';
import { SignInSignUpContainer } from '../components/PaperOnCenter';

export default function SignIn() {
  return (
    <SignInSignUpContainer
      NoticeBeforeTitle={
        BETA_TESTING ? (
          <Stack pt={1}>
            <Typography fontWeight="bold" variant="subtitle2">
              This website is in closed beta testing.
            </Typography>
            <Typography variant="body2" color="text.disabled">
              If you're interested in getting an account contact us at{' '}
              <Link href={CONTACT_SUPPORT_LINK}>{SUPPORT_EMAIL}</Link>.
            </Typography>
          </Stack>
        ) : null
      }
      title="Sign In"
      Form={
        <Form
          mutation={submitSignIn}
          Inputs={
            <>
              <EmailInput />
              <PasswordInput autoComplete="current-password" />
            </>
          }
          SubmitButtonTitle="Sign In"
          SecondaryAction={
            BETA_TESTING ? null : (
              <Stack spacing={1}>
                <LinkToAnotherAuth authLink="/signup">
                  Don't have an account? Sign Up
                </LinkToAnotherAuth>
                <LinkToAnotherAuth authLink="/reset-password">
                  Forgot password?
                </LinkToAnotherAuth>
              </Stack>
            )
          }
        />
      }
    />
  );
}
